// Premium Finance Container
export const arcPremiumFinance = {
    type: "none",
    itemId: "premiumFinanceContainer",
    rules: {
        dateOfBirth: {
            "dateOfBirth.valid": {
                all: [
                    { compareDate: ["#dateOfBirth.value", "<", "today"] },
                    { compareDate: ["#dateOfBirth.value", "!!"] }
                ]
            }
        }
    },
    items: [
        // Premium Finance Request
        {
            type: "none",
            itemId: "premiumFinanceRequest",
            className: "container",
            label: "<h2>Premium Finance Request</h2>",
            items: [
                {
                    type: "radioGroup",
                    itemId: "premiumFinanceType",
                    label: "Select identification type:",
                    required: true,
                    items: [
                        {
                            type: "radio",
                            itemId: "socialSecurity",
                            parentItemId: "premiumFinanceType",
                            label: "Social Security"
                        },
                        {
                            type: "radio",
                            itemId: "fein",
                            parentItemId: "premiumFinanceType",
                            label: "FEIN"
                        }
                    ]
                },
                {
                    type: "text",
                    itemId: "socialSecurityNumber",
                    label: "Social Security #:",
                    className: "col-md-6",
                    mask: "000 00 0000",
                    required: true
                },
                {
                    type: "text",
                    itemId: "feinNumber",
                    label: "FEIN #:",
                    className: "col-md-6",
                    mask: "000000000",
                    required: true
                },
                {
                    type: "text",
                    itemId: "dateOfBirth",
                    label: "Date of Birth",
                    className: "col-md-6",
                    mask: "M0/d0/0000",
                    placeholder: "MM/dd/yyyy",
                    required: true
                },
                {
                    type: "none",
                    className: "clearfix",
                    items: [
                        {
                            type: "submit",
                            itemId: "cancelPremiumFinance",
                            label: "Cancel",
                            className: "col-md-6 text-left",
                            value: "cancelPremiumFinance"
                        },
                        {
                            type: "submit",
                            itemId: "submitPremiumFinanceRequest",
                            label: "Submit",
                            className: "col-md-6 text-right",
                            value: "submitPremiumFinanceRequest"
                        }
                    ]
                }
            ]
        },
        // Premium Finance Quote
        {
            type: "none",
            itemId: "premiumFinanceQuote",
            className: "container",
            label: "<h2>Premium Finance Quote</h2>",
            items: [
                // Quote Number
                { type: "none", label: "Premium Finance Quote Number:", className: "bold col-md-6" },
                { type: "none", itemId: "pfQuoteNumber", className: "col-md-6" },
                // Disclaimer
                { type: "none", className: "pfQuoteDisclaimer", label: "Please review the loan terms below. If you decide to proceed with the premium financing option, please use the buttons below to process your down payment." },
                // Total Amount Due
                { type: "none", label: "Total Amount Due:", className: "bold col-md-6" },
                { type: "none", itemId: "pfTotal", className: "col-md-6" },
                // Amount Financed
                { type: "none", label: "Amount Financed:", className: "bold col-md-6" },
                { type: "none", itemId: "pfAmountFinanced", className: "col-md-6" },
                // Installment Amount
                { type: "none", label: "Installment Amount:", className: "bold col-md-6" },
                { type: "none", itemId: "pfInstallmentAmount", className: "col-md-6" },
                // Number of Installments
                { type: "none", label: "Number of Installments:", className: "bold col-md-6" },
                { type: "none", itemId: "pfNumberOfInstallments", className: "col-md-6" },
                // APR%
                { type: "none", label: "APR%:", className: "bold col-md-6" },
                { type: "none", itemId: "pfApr", className: "col-md-6" },
                // Down Payment
                { type: "none", label: "Down Payment:", className: "bold col-md-6" },
                { type: "none", itemId: "pfDownPayment", className: "col-md-6" }
            ]
        },
        // Premium Finance Terms
        {
            type: "none",
            itemId: "premiumFinanceTerms",
            className: "container",
            items: [
                { type: "none", className: "premiumFinanceAgreement", label: `Checking the box below and entering my Name and Position constitutes my signature on the Commercial Premium Finance Agreement ("PFA") and certifies that I have read and understand all of the terms and conditions of the PFA relating to the financing of the policy premiums listed in this application and the rights of the premium finance company, and I agree to be bound by all of the terms and conditions of this PFA, a copy of which I have printed or saved for my records.` },
                { type: "checkbox", itemId: "acceptPremiumFinanceTerms", label: "Accept", required: true },
                { type: "text", itemId: "premiumFinanceSignature", label: "Signature", required: true },
                { type: "none", itemId: "premiumFinanceAgreementRequired", className: "col-md-8", label: "Please view the Premium Finance Agreement before continuing." },
                { type: "submit", itemId: "viewPremiumFinanceAgreement", label: "View PFA", className: "col-md-4 text-right", value: "downloadPremiumFinanceAgreement", required: true, valid: false },
                { type: "submit", itemId: "cancelPremiumFinance", label: "Cancel", className: "col-md-6 text-left", value: "cancelPremiumFinance" },
                { type: "submit", itemId: "submitPremiumFinanceTerms", label: "Submit", className: "col-md-6 text-right", value: "submitPremiumFinanceTerms" }
            ]
        },
        // Premium Finance Payment Type
        {
            type: "radioGroup",
            itemId: "premiumFinancePaymentType",
            className: "container",
            label: "Please select Premium Financing payment option:",
            required: true,
            visible: false,
            items: [
                {
                    type: "radio",
                    itemId: "pfCreditCard",
                    parentItemId: "premiumFinancePaymentType",
                    label: "Credit Card"
                },
                {
                    type: "radio",
                    itemId: "pfAch",
                    parentItemId: "premiumFinancePaymentType",
                    label: "ACH"
                }
            ]
        }
    ]
};
